import contactAvif1280 from './contact-1280.avif';
import contactWebp1280 from './contact-1280.webp';
import contactAvif1920 from './contact-1920.avif';
import contactWebp1920 from './contact-1920.webp';
import contactAvif640 from './contact-640.avif';
import contactWebp640 from './contact-640.webp';
import galleryAvif1280 from './gallery-1280.avif';
import galleryWebp1280 from './gallery-1280.webp';
import galleryAvif1920 from './gallery-1920.avif';
import galleryWebp1920 from './gallery-1920.webp';
import galleryAvif640 from './gallery-640.avif';
import galleryWebp640 from './gallery-640.webp';
import shopAvif1280 from './shop-1280.avif';
import shopWebp1280 from './shop-1280.webp';
import shopAvif1920 from './shop-1920.avif';
import shopWebp1920 from './shop-1920.webp';
import shopAvif640 from './shop-640.avif';
import shopWebp640 from './shop-640.webp';
import usesAvif1280 from './uses-1280.avif';
import usesWebp1280 from './uses-1280.webp';
import usesAvif1920 from './uses-1920.avif';
import usesWebp1920 from './uses-1920.webp';
import usesAvif640 from './uses-640.avif';
import usesWebp640 from './uses-640.webp';
import visualizerAvif1280 from './visualizer-1280.avif';
import visualizerWebp1280 from './visualizer-1280.webp';
import visualizerAvif1920 from './visualizer-1920.avif';
import visualizerWebp1920 from './visualizer-1920.webp';
import visualizerAvif640 from './visualizer-640.avif';
import visualizerWebp640 from './visualizer-640.webp';

/** One hero picture: the same 16:9 image at three widths, in two formats (`scripts/gen-page-heroes.ts`). */
export interface HeroArtImages {
  avif: { 640: string; 1280: string; 1920: string };
  webp: { 640: string; 1280: string; 1920: string };
}

/** The artwork of the page heroes: crops of the catalogue's stone photographs, lit and arranged per page. */
export const HERO_ART = {
  /** `/shop` — six standing slabs on a polished floor, a brass light line under them. */
  shop: {
    avif: { 640: shopAvif640, 1280: shopAvif1280, 1920: shopAvif1920 },
    webp: { 640: shopWebp640, 1280: shopWebp1280, 1920: shopWebp1920 },
  },
  /** `/visualizer` — a blueprint "before" beside the stone "after", the divider's handle and a row of swatches. */
  visualizer: {
    avif: { 640: visualizerAvif640, 1280: visualizerAvif1280, 1920: visualizerAvif1920 },
    webp: { 640: visualizerWebp640, 1280: visualizerWebp1280, 1920: visualizerWebp1920 },
  },
  /** `/contact-us` — sample tiles on a dark table, a brass tape measure and a pencil, daylight from the left. */
  contact: {
    avif: { 640: contactAvif640, 1280: contactAvif1280, 1920: contactAvif1920 },
    webp: { 640: contactWebp640, 1280: contactWebp1280, 1920: contactWebp1920 },
  },
  /** `/gallery` — a wall of nine framed photographs of the catalogue's stones under a brass picture light. */
  gallery: {
    avif: { 640: galleryAvif640, 1280: galleryAvif1280, 1920: galleryAvif1920 },
    webp: { 640: galleryWebp640, 1280: galleryWebp1280, 1920: galleryWebp1920 },
  },
  /** `/where-to-use` — a staircase of six granites climbing to the right over a black and white tiled floor. */
  uses: {
    avif: { 640: usesAvif640, 1280: usesAvif1280, 1920: usesAvif1920 },
    webp: { 640: usesWebp640, 1280: usesWebp1280, 1920: usesWebp1920 },
  },
} as const satisfies Record<string, HeroArtImages>;
